<div class="flex gap-4 mb-8">
  <span *ngIf="dados.plano.formasPagamento.indexOf('Cartão de crédito') > -1" class="pill" (click)="togglePagamento(FormaPagamentoEnum.CARTAO_CREDITO)"
    [class.pill--active]="pagamento === FormaPagamentoEnum.CARTAO_CREDITO">Cartão
    de crédito</span>

  <span *ngIf="dados.plano.formasPagamento.indexOf('Débito em conta') > -1" class="pill" (click)="togglePagamento(FormaPagamentoEnum.DEBITO_CONTA)"
    [class.pill--active]="pagamento === FormaPagamentoEnum.DEBITO_CONTA">Débito
    em conta</span>
</div>